const caixaOperationType = {
  CONTA_CORRENTE_PESSOA_FISICA: '001',
  CONTA_CORRENTE_PESSOA_JURIDICA: '003',
  POUPANCA: '013',
  POUPANCA_NOVA_VARIACAO: '1288',
  POUPANCA_PESSOA_JURIDICA: '022',
  CONTA_FACIL: '023',
  ENTIDADES_PUBLICAS: '006'
};

module.exports = caixaOperationType;
